namespace GeniuzPOS.Purchase {
    export interface ListAppCreditNoteRow {
        SendForAppfg?: sendapp;
        WaitLv?: number;
        WaitApprove?: string;
        SysDocNo?: string;
        ItemTypeFg?: POTypeFg;
        SupplierId?: string;
        NetTotalInVat?: number;
        CreditNoteNo?: string;
        DocDate?: string;
        RefDocNo1?: string;
        RefDocNo2?: string;
        LastApprove?: string;
        ApproveDate?: string;
        ShipId?: string;
        Remark?: string;
    }

    export namespace ListAppCreditNoteRow {
        export const idProperty = 'SysDocNo';
        export const nameProperty = 'WaitApprove';
        export const localTextPrefix = 'Purchase.ListAppCreditNote';
        export const lookupKey = 'Purchase.ListAppCreditNote';

        export function getLookup(): Q.Lookup<ListAppCreditNoteRow> {
            return Q.getLookup<ListAppCreditNoteRow>('Purchase.ListAppCreditNote');
        }
        export const deletePermission = '5Purchase:ใบส่งคืนสินค้า(ใบลดหนี้)(PC):อนุมัติ:Modify';
        export const insertPermission = '5Purchase:ใบส่งคืนสินค้า(ใบลดหนี้)(PC):อนุมัติ:Modify';
        export const readPermission = '5Purchase:ใบส่งคืนสินค้า(ใบลดหนี้)(PC):อนุมัติ:View';
        export const updatePermission = '5Purchase:ใบส่งคืนสินค้า(ใบลดหนี้)(PC):อนุมัติ:Modify';

        export declare const enum Fields {
            SendForAppfg = "SendForAppfg",
            WaitLv = "WaitLv",
            WaitApprove = "WaitApprove",
            SysDocNo = "SysDocNo",
            ItemTypeFg = "ItemTypeFg",
            SupplierId = "SupplierId",
            NetTotalInVat = "NetTotalInVat",
            CreditNoteNo = "CreditNoteNo",
            DocDate = "DocDate",
            RefDocNo1 = "RefDocNo1",
            RefDocNo2 = "RefDocNo2",
            LastApprove = "LastApprove",
            ApproveDate = "ApproveDate",
            ShipId = "ShipId",
            Remark = "Remark"
        }
    }
}
